'use client'

import { Link } from 'react-router-dom'

import styles from './NotFound.module.css'

/*
 * 還沒搬過來的頁也會落到這裡（router/routes.jsx 的 page() 找不到檔案時
 * 會退到這一支）。搬一頁就少一頁，不是錯誤。
 */
export default function NotFound() {
  return (
    <main className={styles.wrap}>
      <h1 className={styles.code}>404</h1>
      <p className={styles.text}>這一頁還沒搬過來，或是網址打錯了。</p>
      <Link className={styles.back} to="/">回首頁</Link>
    </main>
  )
}
